// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f627700","927":"6a9b3675"}[chunkId] + ".chunk.js";
};